import axios from 'axios';
import { providerListEndpoint } from '../config';
import getHeaders from '../utils/getHeaders';
import { logger } from '../logger';

const log = logger();

/**
 * Fetch Google Maps API key from the backend
 * @returns {Promise<string|null>} Google Maps API key or null if error occurs
 */
const getGoogleMapsApiKey = async () => {
  try {
    const response = await axios.get(
      `${providerListEndpoint}/config/google-maps`,
      getHeaders(),
    );

    if (response.data?.success && response.data?.data?.apiKey) {
      return response.data.data.apiKey;
    }

    log.warn('Google Maps API key not found in response');
    return null;
  } catch (err) {
    log.error('Error fetching Google Maps API key', err);
    return null;
  }
};

const googleMapsConfigService = {
  getGoogleMapsApiKey,
};

export default googleMapsConfigService;
